import axios from 'axios';
import { getConfig } from '../config/config';
import { serialize } from 'object-to-formdata';

const { authUrl, productUrl, orderUrl } = getConfig();

const config = token => {
  return {
    headers: {
      'Content-type': 'application/json',
      Authorization: 'Bearer ' + token,
    },
  };
};

const formDataConfig = token => {
  return {
    headers: {
      'Content-type': 'multipart/form-data',
      Authorization: `Bearer ${token}`,
    },
  };
};

const formData = values => {
  return serialize(values, {
    nullsAsUndefineds: true,
    noFilesWithArrayNotation: true,
    indices: true,
  });
};

export function getContent(type, token, id, options) {
  switch (type) {
    case 'getAllProducts':
      return axios.get(`${productUrl}/get/all`);
    case 'getTopFour':
      return axios.get(`${productUrl}/get/top_four`);
    case 'getSingleProduct':
      return axios.get(`${productUrl}/product/${id}`);
    case 'getUserCartProducts':
      return axios.get(`${productUrl}/cart`, config(token));
    case 'getAdminOrders':
      return axios.get(`${orderUrl}/get_all_orders`, config(token));
    case 'getSingleOrderDetails':
      return axios.get(`${orderUrl}/order_details/${id}`, config(token));
    case 'getAllBlogs':
      return axios.get(`${productUrl}/blogs`, config(token));
    case 'getAllPincodes':
      return axios.get(`${productUrl}/pincode/get`, config(token));

    default:
      break;
  }
}

export function submitData(type, token, values, id) {
  switch (type) {
    case 'createProduct':
      return axios.post(`${productUrl}/create`, formData(values), formDataConfig(token));
    case 'editProduct':
      return axios.post(`${productUrl}/edit/${id}`, formData(values), formDataConfig(token));
    case 'saveCartProducts':
      return axios.post(`${productUrl}/cart`, values, config(token));
    case 'placeUserOrder':
      return axios.post(`${productUrl}`, values, config(token));
    case 'updateOrderStatus':
      return axios.post(`${orderUrl}/status/update`, values, config(token));
    case 'specialOffers':
      return axios.post(`${productUrl}/offer/email`, values, config(token));
    case 'orderOTP':
      return axios.post(`${orderUrl}/order_otp`, values, config(token));
    case 'validateOrderOTP':
      return axios.post(`${orderUrl}/validate_order_otp`, values, config(token));
    case 'createBlog':
      return axios.post(`${productUrl}/blog/create`, formData(values), formDataConfig(token));
    case 'editBlog':
      return axios.post(`${productUrl}/blog/edit/${id}`, formData(values), formDataConfig(token));
    case 'createPincode':
      return axios.post(`${productUrl}/pincode/create`, values, config(token));
    case 'editPincode':
      return axios.post(`${productUrl}/pincode/edit/${id}`, values, config(token));

    default:
      break;
  }
}
